import React, { useState, useEffect } from "react";
import Breadcrumb from "../../../../components/Breadcrum";
import { ArrowRight } from "lucide-react";
import "./Construction.css";

export default function Construction () {
    const ConstructionProducts = [
        {
            id: 1,
            name: "ELASTOMERIC COATING",
            image: "/assets/img/Construction/ELASTOMERIC-COATING.jpg",
            usage: [
                {
                    title: "EP 50 U",
                    points: [
                        "Pure acrylic Versatile modified  emulsion",
                        "It is designed with state of art technology which crosslinks in the presence of ultraviolet (UV3) forming three dimensional network in the film.",
                        "Film exhibit excellent DPuR, Tensile & Elongation.",
                        "Demonstrate good crack bridging performance",
                        "Creates water barrier property and displays water vapour permeability",
                    ],
                },
            ],
        },
        {
            id: 2,
            name: "DAMP PROTECT",
            image: "/assets/img/Construction/DAMP-PROTECT.jpg",
            usage: [
                {
                    title: "5800",
                    points: [
                        "Good Weatherability and Excellent Water resistance",
                        "Optimum balance of high flexibility and Dirt pick-up resistance",
                        "Outstanding stability, high Water & Alkali resistance",
                        "Excellence Efflorescence resistance",
                        "Good Water vapor permeability",
                        " One binder for both Top & Mid coats",
                    ],
                },
                {
                    title: "Elasto 50",
                    points: [
                        "Good Weatherability",
                        "Optimum balance of high flexibility and DPuR.",
                        "Outstanding stability, high water & alkali resistance",
                        "Excellence efflorescent resistance",
                        "Good water vapor permeability",
                    ],
                },
            ],
        },
        {
            id: 3,
            name: "ANTI-CARBONATION",
            image: "/assets/img/Construction/ANTI-CARBONATION.jpg",
            usage: [
                {
                    title: "EPX 762E",
                    points: [
                        "EPX 762E is an aqueous APEO free and Formaldehyde free pure acrylic emulsion with 62% solid product.",
                        "It is a new generation all acrylic elastomeric binder.",
                        "It is specifically design for exterior application but can also be used as ceiling paints where crack bridging performance is required.",
                        "Elastomeric UV curable coating for exterior application and sealants.",
                        "This emulsion having good adhesion and water resistance properties",
                    ],
                },
            ],
        },
        {
            id: 4,
            name: "Curing Compound",
            image: "/assets/img/Construction/Curing-Compound.jpg",
            usage: [
                {
                    title: "AA301",
                    points: [
                        "Fine particle size",
                        "Low coalescent demand",
                        "Optically transparent appearance after drying",
                        "Excellent resistance to water blushing",
                        "Early block resistance",
                    ],
                },
                {
                    title: "5240 Nano",
                    points: [
                        "Excellent alkali & efflorescence resistance",
                        "Physical barrier to water transport",
                        "Chemical barrier to salt migration",
                        "Excellent substrate penetration & top coat adhesion",
                        "Ideal for high alkaline concrete",
                        "Prevention of top coat defects, lo be applied over concrete, plaster or brick, masonry surfaces",
                        "Recommended for porous substrates like Gypsum, Cement plaster and particle board.",
                    ],
                },
            ],
        },
        {
            id: 5,
            name: "Water Proofing",
            image: "/assets/img/Construction/Water-Proofing.jpg",
            usage: [
                {
                    title: "KC 1",
                    points: [
                        "Suitable for crack filling with cement primers",
                        "Used for water proofing and damp proofing",
                        "Excellent adhesion on different surfaces like wood, concrete, bricks",
                        "Ideal for thin section application",
                    ],
                },
                {
                    title: "J76 C",
                    points: [
                        "Suitable for crack filling with cement primers",
                        "Used for water proofing and damp proofing",
                        "Excellent adhesion on different surfaces like wood, concrete, bricks",
                        "Ideal for thin section application",
                    ],
                },
                {
                    title: "J76 C",
                    points: [
                        "Styrene acrylic emulsion",
                        "Used for water proofing and damp proofing  on terrace /ceilings",
                        "Suggested for excellent bonding to old concrete and masonry surface",
                        "Also used for Bituminous water proofing/ roof coating",
                    ],
                },
            ],
        },
        {
            id: 6,
            name: "RDP 100",
            image: "/assets/img/Construction/RDP-100.jpg",
            usage: [
                {
                    title: "RDP 100",
                    points: [
                        "Exhibit improved adhesion, flexural strength, deformability, abrasion resistance and are easier to process. Leveling, thixotropy and water retention are essentially unaffected.",
                        "Its suggested for use in water base paints and coating formulation with wide range of pH range.",
                        "It is highly compatible with various HASE  thickeners and rheology modifiers",
                        "It is more efficient in the dispersing TiO2 and minerals slurries",
                        "Recommended for the flat primer, low VOC paints, interior , exterior flat & semi-gloss paints",
                    ],
                },
            ],
        },
        {
            id: 7,
            name: "SB & XSB Latex",
            image: "/assets/img/Construction/SB-XSB-Latex.jpg",
            usage: [
                {
                    title: "Application",
                    points: [
                        "Waterproofing",
                        "Bonding Agents",
                        "Elastomer Paints",
                        "Structural Repair",
                        "Paper and Paperboard",
                        "Construction",
                        "Tufted & Woven",
                        "Non-Woven Carpets",
                        "Textile Finishing & Coating",
                        "Geotextile",
                    ],
                },
            ],
        },
        {
            id: 8,
            name: "XNB Latex",
            image: "/assets/img/Construction/XNB-Latex.jpg",
            usage: [
                {
                    title: "Application",
                    points: [
                        "Examination Gloves",
                        "Industrial Gloves",
                        "Industrial Gloves",
                    ],
                },
            ],
        },
        {
            id: 9,
            name: "Vinyl Pyridine Latex",
            image: "/assets/img/Construction/Vinyl-Pyridine-Latex.jpg",
            usage: [
                {
                    title: "Application",
                    points: [
                        "Dipping of Nylon",
                        "Rayon and Polyester Fabric for Tyre Cord",
                        "Belting applications",
                    ],
                },
            ],
        },
        {
            id: 10,
            name: "Pure Acrylic & Styrene-Acrylic Latex",
            image: "/assets/img/Construction/Pure-Acrylic-Styrene-Acrylic-Latex.jpg",
            usage: [
                {
                    title: "Application",
                    points: [
                        "Paper and Paperboard",
                        "Backing for Tufted Carpets",
                        "Tertiary Carpets Backing",
                        "Waterproofing",
                        "China Mosaic",
                        "Textiles",
                        "Automotive Carpets",
                        "Construction",
                    ],
                },
            ],
        },
        {
            id: 11,
            name: "NBR Latex",
            image: "/assets/img/Construction/NBR-Latex.jpg",
            usage: [
                {
                    title: "Application",
                    points: [
                        "Jointing Sheets",
                        "Brake Pads and Lining",
                        "Binder for Cork Sheets",
                    ],
                },
            ],
        },
        {
            id: 12,
            name: "NBR",
            image: "/assets/img/Construction/NBR.jpg",
            usage: [
                {
                    title: "Application",
                    points: [
                        "Auto Components",
                        "Hoses",
                        "Rice Dehusking Rollers",
                        "LPG Hoses",
                        "Insulation Foam",
                        "Textile Cots & Aprons",
                        "Jointing Sheets",
                    ],
                },
            ],
        },
        {
            id: 13,
            name: "NBR - PVC Polyblends",
            image: "/assets/img/Construction/NBR-PVC-Polyblends.jpg",
            usage: [
                {
                    title: "Application",
                    points: [
                        "LPG Hoses",
                        "Printing and Industrial Rollers",
                        "Auto Components",
                        "Fuel Mangement Systems",
                    ],
                },
            ],
        },
        {
            id: 14,
            name: "HSR (High Styrene Rubber)",
            image: "/assets/img/Construction/HSR-High-Styrene-Rubber.jpg",
            usage: [
                {
                    title: "Application",
                    points: [
                        "Footwear",
                        "Hawai Chappal",
                        "Micro-Cellular Sheets",
                        "High Hardness Rubber Goods",
                    ],
                },
            ],
        },
        {
            id: 15,
            name: "PNBR (Powdered Nitrile Butadiene Rubber)",
            image: "/assets/img/Construction/PNBR-Powdered-Nitrile-Butadiene-Rubber.jpg",
            usage: [
                {
                    title: "Application",
                    points: [
                        "PVC Modifications",
                        "Footwear",
                        "Jointing Sheets",
                        "Gaskets",
                        "Brake Liners & Pads",
                    ],
                },
            ],
        },
    ];

    const defaultImage =
        "https://upload.wikimedia.org/wikipedia/commons/7/79/Construction_%28PP%29_Granules.jpg";

    const [selectedProduct, setSelectedProduct] = useState(null);
    const closeModal = () => setSelectedProduct(null);

    return (
        <>
            <Breadcrumb
                title="Construction Product"
                backgroundImage="./assets/img/contact-banner.png"
                height="40vh"
            />

            <section className="pp-section">
                <div className="container">
                    <h1 className="pp-title">Construction Product</h1>
                    <p className="pp-subtitle">
                        Explore our advanced construction products delivering 
                        quality, durability, and performance across industries.
                    </p>

                    <div className="pp-grid">
                        {ConstructionProducts.map((product) => (
                            <div className="pp-card" key={product.id}>
                                <div className="pp-img-box">
                                    <img
                                        src={product.image || defaultImage}
                                        alt={product.name}
                                        onError={(e) => (e.target.src = defaultImage)}
                                    />
                                </div>
                                <div className="pp-info">
                                    <h2 className="pp-name">{product.name}</h2>
                                    <button
                                        className="view-btn"
                                        onClick={() => setSelectedProduct(product)}
                                    >
                                        View Details <ArrowRight size={16} />
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>

                    {selectedProduct && (
                        <div className="modal-overlay" onClick={closeModal}>
                            <div
                                className="modal-content"
                                onClick={(e) => e.stopPropagation()}
                            >
                                <img
                                    src={selectedProduct.image || defaultImage}
                                    alt={selectedProduct.name}
                                    className="modal-image"
                                />
                                <h2 className="modal-title">{selectedProduct.name}</h2>

                                <div className="usage-section">
                                    {selectedProduct.usage.map((section, index) => (
                                        <div key={index} className="usage-block">
                                            <h3>{section.title}</h3>
                                            <ul>
                                                {section.points.map((point, i) => (
                                                    <li key={i}>{point}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    ))}
                                </div>

                                <button className="close-btn" onClick={closeModal}>
                                    Close
                                </button>
                            </div>
                        </div>
                    )}
                </div>
            </section>
        </>
    );
}